import { render } from "./CheckoutWhiteBeCrazy.vue?vue&type=template&id=70d5847a&scoped=true"
import script from "./CheckoutWhiteBeCrazy.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteBeCrazy.vue?vue&type=script&lang=js"

import "./CheckoutWhiteBeCrazy.vue?vue&type=style&index=0&id=70d5847a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d5847a"]])

export default __exports__